<div class="table-container">
  @if (data) {
    <p-table [value]="data.data" [scrollable]="true" class="p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>ID</th>
          <th>EVENTO</th>
          <th>TIPO</th>
          <th>VALOR SOLICITADO</th>
          <th>DATA ABERTURA</th>
          <th>DATA ENCERRAMENTO</th>
          <th>STATUS</th>
          <th>MAIS INFO</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-task>
        <tr>
          <td>{{ task.id }}</td>
          <td>{{ task.event?.title ?? "N/A" }}</td>
          <td>{{ task.task_type | taskType }}</td>
          <td class="solicitations-table__amount">
            @if (requestedAmount(task); as amount) {
              {{ amount | currency: "BRL" : "symbol" : "1.2-2" }}
            } @else {
              —
            }
          </td>
          <td>{{ task.created_at | date: "short" }}</td>
          <td>{{ task.status !== "pending" ? (task.updated_at | date: "short") : "-" }}</td>
          <td>
            <span class="solicitations-table__status solicitations-table__status--{{ task.status }}">
              {{ task.status | requestStatusEnum }}
            </span>
          </td>
          <td>
            <button mat-icon-button aria-label="Ver detalhes" (click)="viewDetailsClick.emit(task)">
              <mat-icon>visibility</mat-icon>
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-paginator
      (onPageChange)="pageChange.emit($event)"
      [first]="first"
      [rows]="rows"
      [totalRecords]="data.meta.total_count || 0"
      [showCurrentPageReport]="false"
      [showPageLinks]="false"
      [showJumpToPageDropdown]="false"
      [rowsPerPageOptions]="[10, 20, 30]"
      currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords}" />
  } @else {
    <p-skeleton height="350px" />
  }
</div>
